/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dx-user-bar[_ngcontent-%COMP%]{padding:0 16px}.dx-user-info__line[_ngcontent-%COMP%]{display:block;color:rgba(0,19,86,.4);font-weight:500;font-size:14px;text-align:right}\n/*# sourceMappingURL=dx-user-bar.component.css.map*/"];
export { styles as styles };
